import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { EditMessageProvider } from "../../context/EditingMessage/EditingMessageContext";
import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import MessagesList from "../MessagesList";
import TicketInfo from "../TicketInfo";

const SpyTicketModal = ({ ticketId, open, onClose }) => {
  const { t } = useTranslation();
  const [ticket, setTicket] = useState(null);
  const [contact, setContact] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !ticketId) return;
    setLoading(true);
    api.get(`/tickets/${ticketId}`)
      .then(({ data }) => {
        setTicket(data);
        setContact(data.contact);
      })
      .catch(err => toastError(err, t))
      .finally(() => setLoading(false));
  }, [open, ticketId, t]);

  const handleClose = () => {
    setTicket(null);
    setContact({});
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, py: 1, pr: 1 }}>
        <VisibilityIcon fontSize="small" color="action" />
        <Typography variant="subtitle1" sx={{ flex: 1, fontWeight: 500 }}>
          Visualizando ticket #{ticketId} — somente leitura
        </Typography>
        <IconButton size="small" onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      {ticket && (
        <>
          <Box sx={{ px: 2, py: 1, backgroundColor: "background.paper" }}>
            <TicketInfo contact={contact} ticket={ticket} onClick={() => {}} />
          </Box>
          <Divider />
        </>
      )}

      <DialogContent sx={{ p: 0, height: 500, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
            <CircularProgress size={32} />
          </Box>
        ) : ticket ? (
          <ReplyMessageProvider>
            <EditMessageProvider>
              <MessagesList
                ticketId={String(ticketId)}
                isGroup={ticket.isGroup}
                onClick={() => {}}
              />
            </EditMessageProvider>
          </ReplyMessageProvider>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default SpyTicketModal;
